import { Datagrid, LongTextField } from "ra-friendsofbabba";
import { LoadingIndicator, List as RaList, TextField } from "react-admin";

import Actions from "../component/list/Actions";
import ExportButton from "../component/button/ExportButton";
import Filters from "./Filters";
import FlagInput from "./inputs/FlagInput";
import React from "react";
import RecordInput from "./inputs/RecordInput";

const ListData = (props) => {
  if (props.loading) {
    return <LoadingIndicator />;
  }
  return (
    <Datagrid {...props}>
      <TextField source="id" />
      <LongTextField source="fullname" />
      <LongTextField source="year_1_eval_state" sortable={false} />
      <LongTextField source="year_2_eval_state" sortable={false} />
      <LongTextField source="year_3_eval_state" sortable={false} />
      <FlagInput source="is_payed_1" />
      <RecordInput source="payed_1_amount" type="number" />
      <FlagInput source="is_payed_2" />
      <RecordInput source="payed_2_amount" type="number" />
      <RecordInput source="notes" type="text" maxLength={255} />
    </Datagrid>
  );
};
const List = (props) => (
  <RaList
    {...props}
    filters={<Filters />}
    actions={
      <Actions canExport={false} canCreate={false}>
        <ExportButton />
      </Actions>
    }
    perPage={25}
    sort={{ field: "ExecutiveProjects.id", order: "DESC" }}
  >
    <ListData />
  </RaList>
);
export default List;
